/**
 * acquisition.ts — cc_tasks row 219 (T259). Where this visitor came from, for our own funnel:
 * { channel: "paid" | "organic" | "direct" | "other", click_id?, click_param?, utm?, landing?, landed_at? }.
 *
 * public/google-tag.js (on every page, the SPA shell included) captures it on landing and
 * keeps it 90 days (window.mfAcq; v0.7, cc_tasks row 307, T341 added the campaign labels, the
 * landing path and time). This is only the typed reader, so every event and every new Full
 * Report order the app sends carries the same answer. null = opted out (Global Privacy Control /
 * Do Not Track) or google-tag.js not on the page.
 */
export interface Acquisition {
  channel: "paid" | "organic" | "direct" | "other";
  click_id?: string;
  click_param?: string;
  utm?: { source?: string; medium?: string; campaign?: string; term?: string; content?: string };
  landing?: string;
  landed_at?: string;
}

export function acquisition(): Acquisition | null {
  try {
    const f = (window as unknown as { mfAcq?: () => Acquisition | null }).mfAcq;
    return typeof f === "function" ? f() : null;
  } catch {
    return null;
  }
}
